import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { RoutesEnum } from '../enums/routes.enum';
import { UserRoleEnum } from '../enums/user.enums';
import { AuthStore } from '../stores/auth.store';

export function permissionsGuard(allowedRoles: UserRoleEnum[]): CanActivateFn {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    if (!authStore.isLoggedIn()) {
      authStore.logout();
      router.navigateByUrl(RoutesEnum.COMMON_LOGIN);
      return false;
    }

    if (authStore.userRole() && allowedRoles.includes(authStore.userRole()!)) {
      return true;
    } else {
      return false;
    }
  };
}
